import type { JSX } from 'react'
import type { IGridLoadingByCardProps } from '../GridLoadingByCard'

import { TextBoxColors } from 'atoms/TextBox'
import { CardsInRow } from 'containers/RowContainer'
import { GridLoadingByCard } from '../GridLoadingByCard'
import {
  GridLoadingByCardPaddings,
  GridLoadingByCardTitleMargins,
} from '../GridLoadingByCard.h'

export interface IH5GridLoadingByCardProps extends IGridLoadingByCardProps {}

export const H5GridLoadingByCard = ({
  children,
  title = '',
  cardsInRow = CardsInRow.Horizontal_5,
  paddings = GridLoadingByCardPaddings.SIZE_10,
  colorTitle = TextBoxColors.TEXT_ICON_PRIMARY,
  marginTitle = GridLoadingByCardTitleMargins.SIZE_10,
  ...rest
}: IH5GridLoadingByCardProps): JSX.Element => (
  <GridLoadingByCard
    title={title}
    cardsInRow={cardsInRow}
    paddings={paddings}
    colorTitle={colorTitle}
    marginTitle={marginTitle}
    {...rest}
  >
    {children}
  </GridLoadingByCard>
)
